import { categories } from '@/mocks/melons';

interface Props {
  activeCat: string;
  onSelect: (id: string) => void;
}

const accents = [
  'bg-primary-100 text-primary-700',
  'bg-accent-100 text-accent-900',
  'bg-secondary-100 text-secondary-800',
  'bg-background-200 text-primary-700',
  'bg-accent-100 text-secondary-800',
  'bg-primary-100 text-secondary-800',
];

export default function CategoryTiles({ activeCat, onSelect }: Props) {
  const go = (id: string) => {
    onSelect(id);
    document.querySelector('#featured')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <section className="border-b border-background-200 bg-background-50 py-12 md:py-16">
      <div className="container-page">
        <div className="flex flex-col items-start gap-3">
          <span className="inline-flex items-center gap-2 rounded-full border border-secondary-200 bg-secondary-100 px-3 py-1 text-xs font-medium tracking-wide text-secondary-900">
            <i className="ri-grid-line" aria-hidden="true" />
            瓜田栏目 · 按主题逛
          </span>
          <h2 className="text-2xl font-bold text-foreground-950 md:text-[34px]">
            想去哪块<span className="ml-2 text-primary-600">瓜田逛逛？</span>
          </h2>
          <p className="max-w-2xl text-sm text-foreground-600 md:text-[15px]">点击栏目即可筛选下方瓜田精选，按直播带货、主播圈、品牌争议等主题快速找到你想吃的瓜。</p>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {categories.map((c, i) => (
            <button
              key={c.id}
              type="button"
              onClick={() => go(c.id)}
              className={`group flex items-start gap-4 rounded-xl border p-4 text-left transition-all md:p-5 ${
                activeCat === c.id
                  ? 'border-primary-300 bg-primary-50'
                  : 'border-background-200 bg-background-100 hover:-translate-y-0.5 hover:border-primary-200 hover:bg-background-50'
              }`}
            >
              <span className={`flex h-11 w-11 shrink-0 items-center justify-center rounded-lg text-xl ${accents[i % accents.length]}`}>
                <i className={c.icon} aria-hidden="true" />
              </span>
              <span className="min-w-0 flex-1">
                <span className="flex items-center gap-2">
                  <span className="text-[15px] font-bold text-foreground-950">{c.name}</span>
                  <span className="rounded-full bg-background-200 px-2 py-0.5 text-[11px] font-semibold text-foreground-600">{c.count} 篇</span>
                </span>
                <span className="mt-1 block text-[13px] leading-relaxed text-foreground-600">{c.desc}</span>
                <span className={`mt-2 inline-flex items-center gap-1 text-[13px] font-semibold ${activeCat === c.id ? 'text-primary-700' : 'text-foreground-500 group-hover:text-primary-700'}`}>
                  {activeCat === c.id ? '正在查看' : '去看看'}
                  <i className="ri-arrow-right-s-line" aria-hidden="true" />
                </span>
              </span>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}